import { SALES_ORDER_REGISTER_REPORT_FAILURE, SALES_ORDER_REGISTER_REPORT_REQUEST, SALES_ORDER_REGISTER_REPORT_SUCCESS } from "../types";
  
  const initialState = {
    salesOrderReports: {},
    loading: false,
    error: null,
  };
  
  const salesOrderReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case SALES_ORDER_REGISTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case SALES_ORDER_REGISTER_REPORT_SUCCESS: {
        return {
          ...state,
          salesOrderRegisterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case SALES_ORDER_REGISTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default salesOrderReportReducer;
  